export const FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_REQUEST = 'FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_REQUEST';
export const FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_SUCCESS = 'FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_SUCCESS';
export const FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_FAILURE = 'FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_FAILURE';

export const GET_LOCKERS_COUNT = 'GET_LOCKERS_COUNT';

export const FETCH_LOCKER_WISE_VENDOR_APPOINTMENTS_SUCCESS = 'FETCH_LOCKER_WISE_VENDOR_APPOINTMENTS_SUCCESS';
